import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { authAPI } from '../services/api';
import './OfflineIndicator.css';

const OfflineIndicator: React.FC = () => {
  const { serverAvailable, setServerAvailable } = useAuth();

  const handleRetry = async () => {
    try {
      const isHealthy = await authAPI.healthCheck();
      if (isHealthy) {
        setServerAvailable(true);
        // Optionally refresh the page to retry auth
        window.location.reload();
      }
    } catch (error) {
      console.log('Manual retry failed:', error);
    }
  };

  if (serverAvailable) {
    return null;
  }

  return (
    <div className="offline-indicator">
      <div className="offline-content">
        <span className="offline-icon">⚠️</span>
        <span className="offline-text">Server temporarily unavailable</span>
        <button onClick={handleRetry} className="retry-button">
          Retry
        </button>
      </div>
    </div>
  );
};

export default OfflineIndicator; 